import { motivatedSellerConfig } from './motivatedSeller';

import type { LeadScoreConfig } from '../types';

export const LEAD_SCORE_CONFIGS: Record<string, LeadScoreConfig> = {
  'motivated-seller': motivatedSellerConfig,
};
